import React from "react";
import {
  GitBranch, Settings, Building2,
  Search, Plus, Clock, DollarSign, Phone,
  Bell, HelpCircle, MoreHorizontal, ChevronRight,
  Tag, FileText, CheckSquare,
  Wifi, WifiOff, QrCode, RefreshCw,
  Trash2, Edit2, Eye, EyeOff,
  Mail, Lock, TrendingUp, TrendingDown,
  ArrowUp, ArrowDown, ChevronDown,
  X, Check, Info, Star,
  Paperclip, Smile, Hash, ArrowRight, CornerDownLeft,
  LogOut, Menu, Filter, Download, Upload, Copy, Link,
  PlusCircle, Globe, Mic, MicOff, Square, StopCircle,
  Image, FileImage, ArrowLeftRight, Forward,
  ChevronLeft, Moon, Sun, Repeat, MoreVertical, Pin,
} from "lucide-react";

// ── Custom SVG icons — paths idênticos ao Claude Design v2.0 ─────────────────
const _sz = (content) => ({ size = 15, className = "", strokeWidth = 1.8 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
       stroke="currentColor" strokeWidth={strokeWidth}
       strokeLinecap="round" strokeLinejoin="round" className={className}>
    {content}
  </svg>
);

// Navegação — 4 quadrados arredondados (rx 1.5)
const SzDashboard = _sz(
  <><rect x="3" y="3" width="7" height="7" rx="1.5"/><rect x="14" y="3" width="7" height="7" rx="1.5"/><rect x="3" y="14" width="7" height="7" rx="1.5"/><rect x="14" y="14" width="7" height="7" rx="1.5"/></>
);
// Conversas — balão com cauda curva
const SzMessage = _sz(
  <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/>
);
// Ticket — forma com recorte + linha vertical
const SzTicket = _sz(
  <><path d="M2 9.5V7a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v2.5a2.5 2.5 0 0 0 0 5V17a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-2.5a2.5 2.5 0 0 0 0-5z"/><path d="M13 5v14"/></>
);
// Chatbot — robô com olhos e sorriso
const SzBot = _sz(
  <><rect x="3" y="8" width="18" height="12" rx="2"/><path d="M12 2v4"/><circle cx="9" cy="14" r="1"/><circle cx="15" cy="14" r="1"/><path d="M9 18h6"/></>
);
// Supervisor — linha EKG/heartbeat
const SzActivity = _sz(<polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/>);
// Campanhas — avião de papel
const SzSend = _sz(
  <><path d="M22 2L11 13"/><path d="M22 2l-7 20-4-9-9-4 20-7z"/></>
);
// Base de conhecimento — livro aberto
const SzBook = _sz(
  <><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20V3H6.5A2.5 2.5 0 0 0 4 5.5v14z"/><path d="M4 19.5A2.5 2.5 0 0 0 6.5 22H20v-5"/></>
);
// Relatórios — gráfico de linha com eixos
const SzChart = _sz(
  <><path d="M3 3v18h18"/><path d="M7 16l4-4 4 4 5-5"/></>
);
// Raio — polígono lightning bolt
const SzZap = _sz(<polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>);
// WhatsApp — balão arredondado + L invertido
const SzWhatsApp = _sz(
  <><path d="M3 21l1.65-3.8a9 9 0 1 1 3.4 2.9L3 21"/><path d="M9 10a.5.5 0 0 0 1 0V9a.5.5 0 0 0-1 0v1a5 5 0 0 0 5 5h1a.5.5 0 0 0 0-1h-1a.5.5 0 0 0 0 1"/></>
);
// Contatos — dois usuários
const SzContact = _sz(
  <><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></>
);
// Lead/CRM — seta crescente
const SzTrending = _sz(
  <><path d="M22 7L13.5 15.5l-5-5L2 17"/><path d="M16 7h6v6"/></>
);
// Check circle — círculo com ✓ (atividade: conversa finalizada)
const SzCheckCircle = _sz(
  <><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></>
);
// Warning — triângulo de atenção (SLA crítico)
const SzWarning = _sz(
  <><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></>
);
// User — perfil único (atividade: lead cadastrado)
const SzUser = _sz(
  <><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></>
);
// Sort — 3 linhas decrescentes (header filtro)
const SzSort = _sz(
  <><path d="M3 6h18"/><path d="M7 12h10"/><path d="M10 18h4"/></>
);
// ─────────────────────────────────────────────────────────────────────────────

const ICON_MAP = {
  // Navigation — custom SVGs matching the design
  home:        SzDashboard,
  dashboard:   SzDashboard,
  chat:        SzMessage,
  inbox:       SzMessage,
  contacts:    SzContact,
  contact:     SzContact,
  company:     Building2,
  team:        SzContact,
  user:        SzContact,
  people:      SzContact,
  deal:        SzTrending,
  lead:        SzTrending,
  report:      SzChart,
  performance: SzChart,
  grid:        SzChart,
  settings:    Settings,
  flow:        GitBranch,
  whatsapp:    SzWhatsApp,
  // Actions
  search:      Search,
  plus:        Plus,
  send:        SzSend,
  reply:       CornerDownLeft,
  at:          Mail,
  bell:        Bell,
  help:        HelpCircle,
  dots:        MoreHorizontal,
  tag:         Tag,
  task:        CheckSquare,
  rule:        FileText,
  activity:    SzActivity,
  // Status
  clock:       Clock,
  money:       DollarSign,
  phone:       Phone,
  wifi:        Wifi,
  wifiOff:     WifiOff,
  qr:          QrCode,
  refresh:     RefreshCw,
  // UI
  trash:       Trash2,
  edit:        Edit2,
  eye:         Eye,
  "eye-off":   EyeOff,
  eyeOff:      EyeOff,
  mail:        Mail,
  lock:        Lock,
  trendUp:     TrendingUp,
  trendDown:   TrendingDown,
  arrowUp:     ArrowUp,
  arrowDown:   ArrowDown,
  chevronDown: ChevronDown,
  chevronRight:ChevronRight,
  close:       X,
  x:           X,
  check:       Check,
  checkCircle: SzCheckCircle,
  warning:     SzWarning,
  user:        SzUser,
  message:     SzMessage,
  info:        Info,
  star:        Star,
  attach:      Paperclip,
  emoji:       Smile,
  hash:        Hash,
  arrowRight:  ArrowRight,
  logout:      LogOut,
  menu:        Menu,
  filter:      Filter,
  download:    Download,
  upload:      Upload,
  copy:        Copy,
  link:        Link,
  plusCircle:  PlusCircle,
  globe:       Globe,
  zap:         SzZap,
  mic:         Mic,
  micOff:      MicOff,
  stop:        StopCircle,
  square:      Square,
  image:       Image,
  fileImage:   FileImage,
  transfer:    ArrowLeftRight,
  forward:     Forward,
  ai:          SzBot,
  automation:  SzZap,
  ticket:      SzTicket,
  chevronLeft: ChevronLeft,
  moon:        Moon,
  sun:         Sun,
  cycle:       Repeat,
  queue:       Repeat,
  book:        SzBook,
  moreV:       MoreVertical,
  sort:        SzSort,
  pin:         Pin,
};

export function Icon({ name, size = 15, className = "" }) {
  const Comp = ICON_MAP[name];
  if (!Comp) return <span className={`iconGlyph ${className}`}>{name}</span>;
  return <Comp size={size} className={`iconGlyph ${className}`} strokeWidth={1.8} />;
}

/**
 * SafeZapBolt — ícone quadrado arredondado com borda verde gradiente + bolt interno.
 * Fiel ao design v2.0: rect rx=8 com gradiente diagonal + path do raio dentro.
 *
 * Props:
 *   size   — tamanho em px (quadrado), padrão 28
 *   id     — sufixo para o id do gradiente (evita colisão entre instâncias)
 */
export function SafeZapBolt({ size = 28, id = "a" }) {
  const gradId = `szGrad_${id}`;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Safe Zap"
    >
      <defs>
        <linearGradient id={gradId} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%"   stopColor="#3DEB7E" />
          <stop offset="100%" stopColor="#1FB855" />
        </linearGradient>
      </defs>
      {/* Quadrado arredondado — borda gradiente, sem preenchimento */}
      <rect x="1" y="1" width="32" height="32" rx="8"
            stroke={`url(#${gradId})`} strokeWidth="2" fill="none" />
      {/* Bolt interno — linhas conectadas formando o raio */}
      <path d="M11 9 L23 9 L13 19 L21 19 L11 25"
            stroke={`url(#${gradId})`} strokeWidth="2.6"
            strokeLinecap="round" strokeLinejoin="round" fill="none" />
    </svg>
  );
}

/**
 * SafeZapWordmark — ícone quadrado + "SafeZap" + tagline "CRM Inteligente".
 * Fiel ao design v2.0: "Safe" em var(--text-1), "Zap" em var(--brand-500) #25D366.
 * Fonte: Geist (var(--font)), NÃO Orbitron.
 *
 * Props:
 *   size     — tamanho do ícone em px, padrão 28
 *   variant  — "dark" (texto branco) | "light" (texto escuro) — padrão "dark"
 *   tagline  — exibe "CRM Inteligente" abaixo (default true)
 */
export function SafeZapWordmark({ size = 28, variant = "dark", tagline = true }) {
  const isDark = variant === "dark";
  const nameColor    = isDark ? "var(--text-1, #F2F4F5)"  : "var(--text-1, #0B1011)";
  const taglineColor = isDark ? "var(--text-4, #545B5E)"  : "var(--text-4, #8A9094)";
  const fontSize     = Math.round(size * 0.5);   // 28px icon → 14px text
  const taglineSize  = Math.max(8, Math.round(size * 0.32)); // 28px → ~9px
  return (
    <div className={`szWordmark szWordmark-${variant}`}
         style={{ display: "inline-flex", alignItems: "center", gap: Math.round(size * 0.36), userSelect: "none" }}>
      <SafeZapBolt size={size} id="wm" />
      <div style={{ display: "inline-flex", flexDirection: "column", lineHeight: 1.1 }}>
        {/* "Safe" branco + "Zap" verde — fiel ao design */}
        <span
          className="szWordmarkText"
          style={{
            fontSize,
            fontWeight: 800,
            letterSpacing: 0,
            color: nameColor,
            lineHeight: 1,
            fontFamily: "var(--font, 'Geist', -apple-system, sans-serif)",
          }}
        >
          Safe<span style={{ color: "var(--brand-500, #25D366)" }}>Zap</span>
        </span>
        {tagline && (
          <span
            className="szWordmarkTagline"
            style={{
              fontSize: taglineSize,
              fontWeight: 500,
              letterSpacing: "0.18em",
              color: taglineColor,
              lineHeight: 1,
              marginTop: Math.round(size * 0.11),
              fontFamily: "var(--font, 'Geist', -apple-system, sans-serif)",
              textTransform: "uppercase",
            }}
          >
            CRM Inteligente
          </span>
        )}
      </div>
    </div>
  );
}
